<template>

  <v-card>
    <v-card-title>
      <span class="headline">Update Merchant</span>
    </v-card-title>

    <m-pay-confirm-dialog
      :show="showConfirmationDialog"
      title="Are you sure you want to update Merchant?"
      @yes="update"
      @cancel="showConfirmationDialog = false"
      maxWidth="700px"
    />

    <m-pay-generic-editor
      :bean="merchant"
      :beanProperties="editableMerchantProperties"
      :beanLabels="labels"
      :validationRules="validationRules"
      :loading="loading"
      submitButtonColor="red"
      @submit="confirmUpdate"
      @cancel="cancel"
    >
      <template slot="submitButton">
        Update
        <v-icon right dark>edit</v-icon>
      </template>
    </m-pay-generic-editor>
  </v-card>

</template>

<script>
import MPayGenericEditor from '../MPayGenericEditor';
import MPayConfirmDialog from '../MPayConfirmDialog';

export default {
  name: 'MPayMerchantLimitedEditor',
  props: {
    merchant: { required: true },
    loading: { required: true },
  },
  components: { MPayGenericEditor, MPayConfirmDialog },
  data: () => ({
    showConfirmationDialog: false,
    editableMerchantProperties: [
      'addressLine',
      'zipCode',
      'termsUrl',
      'cardAcceptanceLocation',
    ],
    labels: [
      'Street Address',
      'Zip Code',
      'Terms URL',
      'Card acceptance location',
    ],
    validationRules: [
      '',
      '',
      '',
      '',
    ],
    confirmedMerchant: {},
  }),
  methods: {
    confirmUpdate(merchant) {
      this.showConfirmationDialog = true;
      this.confirmedMerchant = merchant;
    },
    update() {
      this.showConfirmationDialog = false;
      this.$emit('submit', this.confirmedMerchant);
    },
    cancel() {
      this.$router.push({ name: 'business-days' });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/merchant/MPayMerchantLimitedEditor.vue